import { env } from '@skin-seoul/env-utils';

import axios, { AxiosInstance } from 'axios';
import qs from 'qs';
import { attachServerLoggingInterceptor } from './loggingInterceptor';
import { getServiceLogger } from './serviceLogger';

const DEFAULT_LOYALTY_URL = 'https://dev.skin-seoul.com/api';

const convertServerOriginToLoyaltyURL = (url: string) => {
  switch (url) {
    case 'https://dev-api.skin-seoul.com':
      return 'https://dev.skin-seoul.com/api';
    case 'https://staging-api.skin-seoul.com':
      return 'https://staging.skin-seoul.com/api';
    case 'https://api.skin-seoul.com':
      return 'https://skin-seoul.com/api';
    default:
      return DEFAULT_LOYALTY_URL;
  }
};

const getLoyaltyBaseURL = (): string => {
  return convertServerOriginToLoyaltyURL(env('NEXT_PUBLIC_ENV_SERVER_ORIGIN'));
};

export const createSkinSeoulLoyaltyClient = (_baseURL?: string): AxiosInstance => {
  const initialBaseURL = _baseURL ? convertServerOriginToLoyaltyURL(_baseURL) : getLoyaltyBaseURL();

  const isServer = typeof window === 'undefined';

  getServiceLogger().debug('[service/loyaltyClient] Creating Loyalty HTTP client:', {
    isServer,
    baseURL: initialBaseURL,
  });

  const instance = axios.create({
    baseURL: initialBaseURL,
    withCredentials: true,
    adapter: 'fetch',
    paramsSerializer: (params) => qs.stringify(params, { indices: false }),
  });

  // Fix for race condition: re-check baseURL on each request
  instance.interceptors.request.use((config) => {
    if (typeof window !== 'undefined') {
      const currentBaseURL = getLoyaltyBaseURL();
      const configBaseURL = config.baseURL || instance.defaults.baseURL;

      if (currentBaseURL !== DEFAULT_LOYALTY_URL && configBaseURL !== currentBaseURL) {
        getServiceLogger().warn('[service/loyaltyClient] Race condition detected - fixing baseURL:', {
          from: configBaseURL,
          to: currentBaseURL,
        });
        config.baseURL = currentBaseURL;
        instance.defaults.baseURL = currentBaseURL;
      }
    }
    return config;
  });

  attachServerLoggingInterceptor(instance, 'loyaltyClient');

  return instance;
};

// TODO: Need to rename non domain specific client
// Will merge with cartClient
export let loyaltyClient: AxiosInstance = createSkinSeoulLoyaltyClient();

export const setLoyaltyClient = (instance: AxiosInstance) => {
  loyaltyClient = instance;
};
